"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoServerTrailingSlash = void 0;
exports.NoServerTrailingSlash = () => {
    return {
        Server(server, { report, location }) {
            if (!server.url)
                return;
            if (server.url.endsWith('/')) {
                report({
                    message: 'Server `url` should not have a trailing slash.',
                    location: location.child(['url']),
                });
            }
        },
    };
};
